import { useEffect, useState } from 'react';
import { formatearMonto, parsearMontoDesdeTexto } from '../utils/formatoMonto';

/**
 * Input de montos en pesos con separador de miles EN VIVO, para que un cero de más (o de menos)
 * salte a la vista mientras se escribe — acá se manejan montos en millones y un
 * <input type="number"> los muestra todos pegados ("1500000"), fácil de leer mal.
 *
 * Se reformatea en cada tecla (no solo al perder el foco): se le quita todo lo que no sea dígito
 * a lo que escribió el usuario y se vuelve a armar con puntos de miles. El valor que sube por
 * `onChange` siempre es el número (o '' si está vacío) — nunca el texto formateado.
 */
export default function InputMonto({ value, onChange, placeholder, disabled, id, size }) {
    const [texto, setTexto] = useState(formatearMonto(value));

    useEffect(() => {
        setTexto(formatearMonto(value));
    }, [value]);

    const handleChange = (e) => {
        const numero = parsearMontoDesdeTexto(e.target.value);
        setTexto(formatearMonto(numero));
        onChange(numero);
    };

    return (
        <div className="input-group">
            <span className="input-group-text">$</span>
            <input
                id={id}
                type="text"
                inputMode="numeric"
                className={`form-control${size ? ` form-control-${size}` : ''}`}
                placeholder={placeholder}
                disabled={disabled}
                value={texto}
                onChange={handleChange}
            />
        </div>
    );
}
